export enum KlarmeldingTypeEnum {
    Laegekompetence = 1,
    Laegekursus = 2,
}
